import { GuestFieldFormSchema } from '../types';

/**
 * Validates all guests in the array to ensure their guest details meet the required schema.
 * Used to determine if the form is valid before allowing progression to the next step.
 *
 * @param guests - Array of guest objects with guestDetails property
 * @returns true if all guests have valid guest details, false otherwise
 */
export const validateGuestDetails = (guests: any[]): boolean => {
  return guests.every((guest) => GuestFieldFormSchema.safeParse(guest?.guestDetails).success);
};
